import * as React from 'react';

const infoSecSmall = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="20" height="20" rx="4" fill="white"/>
<path d="M15.3289 9.87613H13.6016V5.82902C13.6016 4.11874 12.2102 2.72736 10.4999 2.72736C8.78964 2.72736 7.39826 4.11874 7.39826 5.82902V9.87613H5.6709V5.82902C5.6709 3.1663 7.8372 1 10.4999 1C13.1626 1 15.3289 3.1663 15.3289 5.82902V9.87613Z" fill="url(#paint0_linear_23086_12648)"/>
<path d="M13.2554 19.0551H7.74458C5.6765 19.0551 4 17.3786 4 15.3105V8.45508H17V15.3105C17 17.3786 15.3235 19.0551 13.2554 19.0551Z" fill="url(#paint1_linear_23086_12648)"/>
<path d="M17 8.45483V15.3105C17 17.3786 15.3235 19.0551 13.2555 19.0551H10.5081V8.45483H17Z" fill="url(#paint2_linear_23086_12648)"/>
<path d="M12.2393 12.6055C12.2393 11.6449 11.4606 10.8662 10.5 10.8662C9.53944 10.8662 8.76074 11.6449 8.76074 12.6055C8.76074 13.1881 9.0482 13.7024 9.48791 14.0181V15.9116C9.48791 16.4705 9.94105 16.9237 10.5 16.9237C11.0589 16.9237 11.5121 16.4705 11.5121 15.9116V14.0181C11.9518 13.7024 12.2393 13.188 12.2393 12.6055Z" fill="url(#paint3_linear_23086_12648)"/>
<defs>
<linearGradient id="paint0_linear_23086_12648" x1="12.7724" y1="7.55143" x2="5.86179" y2="3.55348" gradientUnits="userSpaceOnUse">
<stop stop-color="#BDD1E7"/>
<stop offset="1" stop-color="white"/>
</linearGradient>
<linearGradient id="paint1_linear_23086_12648" x1="14.9537" y1="17.3404" x2="-0.213678" y2="10.4518" gradientUnits="userSpaceOnUse">
<stop stop-color="#2744FF"/>
<stop offset="1" stop-color="#B9D5FF"/>
</linearGradient>
<linearGradient id="paint2_linear_23086_12648" x1="15.9782" y1="17.3403" x2="7.28844" y2="15.3695" gradientUnits="userSpaceOnUse">
<stop stop-color="#2744FF"/>
<stop offset="1" stop-color="#B9D5FF"/>
</linearGradient>
<linearGradient id="paint3_linear_23086_12648" x1="11.3185" y1="15.3372" x2="9.21169" y2="14.8358" gradientUnits="userSpaceOnUse">
<stop stop-color="#BDD1E7"/>
<stop offset="1" stop-color="white"/>
</linearGradient>
</defs>
</svg>
);

export default infoSecSmall;